module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Tulip-Fever.c70d401.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Tulip-Fever.jpg
// module id = HvGn
// module chunks = 0